import { makeActionCreator } from '../../../utilities'
import { PulsaraConstants } from './pulsara.constants'

export const setCurrentStep = makeActionCreator(PulsaraConstants.SET_CURRENT_STEP, 'currentStep')
export const setCurrentSubStep = makeActionCreator(PulsaraConstants.SET_CURRENT_SUB_STEP, 'currentSubStep')
export const setLoading = makeActionCreator(PulsaraConstants.SET_LOADING, 'loading')
export const setPulsaraRecords = makeActionCreator(PulsaraConstants.SET_PULSARA_RECORDS, 'pulsaraRecords')
export const setPulsaraDetails = makeActionCreator(PulsaraConstants.SET_PULSARA_DETAILS, 'pulsaraDetails')
export const setPulsaraAttachmentsList = makeActionCreator(
  PulsaraConstants.SET_PULSARA_ATTACHMENTS_LIST,
  'attachmentList'
)
export const setPulsaraAttachments = makeActionCreator(PulsaraConstants.SET_PULSARA_ATTACHMENTS, 'attachments')
export const setImportSelections = makeActionCreator(PulsaraConstants.SET_IMPORT_SELECTIONS, 'importSelections')
export const setPatientSelections = makeActionCreator(PulsaraConstants.SET_PATIENT_SELECTIONS, 'patientSelections')
export const setEmsChartsData = makeActionCreator(PulsaraConstants.SET_EMS_CHARTS_DATA, 'emsChartsData')
export const setSelectedVitals = makeActionCreator(PulsaraConstants.SET_SELECTED_VITALS, 'selectedVitals')
export const setSelectedLabs = makeActionCreator(PulsaraConstants.SET_SELECTED_LABS, 'selectedLabs')
export const setSelectedAttachments = makeActionCreator(
  PulsaraConstants.SET_SELECTED_ATTACHMENTS,
  'selectedAttachments'
)
export const setPulsaraState = makeActionCreator(PulsaraConstants.SET_PULSARA_STATE, 'pulsaraState')
export const initializePatientConflictFromPCR = makeActionCreator(PulsaraConstants.POPULATE_EMS_CHARTS_FROM_PCR)
export const importPulsaraData = makeActionCreator(PulsaraConstants.IMPORT_PULSARA_DATA)
export const resetPulsara = makeActionCreator(PulsaraConstants.RESET_PULSARA)
export const fetchPulsaraRecords = makeActionCreator(PulsaraConstants.FETCH_PULSARA_RECORDS, 'selectedDateRange')
export const fetchPulsaraDetails = makeActionCreator(PulsaraConstants.FETCH_PULSARA_DETAILS, 'selectedPulsaraId')
export const fetchPulsaraAttachments = makeActionCreator(PulsaraConstants.FETCH_PULSARA_ATTACHMENTS)
export const fetchPulsaraAttachmentImage = makeActionCreator(
  PulsaraConstants.FETCH_PULSARA_ATTACHMENT_IMAGE,
  'selectedAttachment'
)
export const deletePulsaraAttachment = makeActionCreator(
  PulsaraConstants.DELETE_PULSARA_ATTACHMENT,
  'pulsaraAttachmentToDelete'
)
export const getPulsaraAttachments = makeActionCreator(PulsaraConstants.GET_PULSARA_ATTACHMENTS)
export const handleResetsOnBack = makeActionCreator(PulsaraConstants.HANDLE_RESETS_ON_BACK)
